export class NumberFormat {
  static formatNumber(number: number): string {
    if (!number) return '-';

    return number.toLocaleString();
  }

  static formatNumberWithCommas(number: number): string {
    if (!number) return '-';

    return number.toLocaleString('en-US', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    });
  }

  static formatNumberWithCommasAndDecimals(number: number): string {
    if (!number) return '-';

    return number.toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  }
}
